export const LAST_TIMESTAMP_KEY = 'utm_timestamp (last)';
export const FIRST_TIMESTAMP_KEY = 'utm_timestamp (first)';
export const FIRST_TOUCH_KEY = 'utm_first';
export const LAST_TOUCH_KEY = 'utm_last';
